import React, {useState, useEffect, useCallback} from 'react';
const isDev = false;
const useMenuSide = () => {
    const [menuSide, setMenuSide] = useState(null)
    useEffect(() => {
        isDev ? setMenuSide(true) :
        setMenuSide(window.storeLocatorData ? window.storeLocatorData['menuside'] ? window.storeLocatorData['menuside'] : false : false)
    }, [])
    return menuSide;
}

export default useMenuSide